import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { searchPlans, CLEAR_REGISTRATION_MESSAGE, CLEAR_ERROR, CLEAR_ALL_MESSAGES } from '../actions/planActions';

// Keep the existing Plan interface
interface Plan {
  brokerID: string;
  employerID: string;
  employerName: string;
  planCode: string;
  id: string;
  brokerName?: string;
  price?: string;
  planName: string;
  planDescription?: string;
}

interface PlanState {
  plans: Plan[];
  loading: boolean;
  error: string | null;
  registrationMessage: string | null;
  searchResults: Plan[];
  registeredPlans: Plan[];
}

// Keep the existing initial state
const initialState: PlanState = {
  plans: [],
  loading: false,
  error: null,
  registrationMessage: null,
  searchResults: [],
  registeredPlans: [],
};

const planSlice = createSlice({
  name: 'plan',
  initialState,
  reducers: {
    clearRegistrationMessage: (state) => {
      state.registrationMessage = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearAllMessages: (state) => {
      state.error = null;
      state.registrationMessage = null;
    },
    registerPlanSuccess: (state, action: PayloadAction<Plan>) => {
      state.registrationMessage = "Plan registered successfully";
      state.error = null;
      state.registeredPlans.push(action.payload);
    },
    registerPlanFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.registrationMessage = null;
    },
    setSearchResults: (state, action: PayloadAction<Plan[]>) => {
      state.searchResults = action.payload;
    },
    addRegisteredPlan: (state, action: PayloadAction<Plan>) => {
      state.registeredPlans.push(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(CLEAR_REGISTRATION_MESSAGE, (state) => {
        state.registrationMessage = null;
      })
      .addCase(CLEAR_ERROR, (state) => {
        state.error = null;
      })
      .addCase(CLEAR_ALL_MESSAGES, (state) => {
        state.error = null;
        state.registrationMessage = null;
      });
  },
});

export const { 
  clearRegistrationMessage, 
  clearError, 
  clearAllMessages, 
  registerPlanSuccess, 
  registerPlanFailure,
  setSearchResults,
  addRegisteredPlan
} = planSlice.actions;

export default planSlice.reducer;